@if ((jobsLoading$ | async) === false) {
  @if (jobs$ | async; as jobs) {
    @if (jobs.length > 0) {
      <button mat-icon-button (click)="onClick()">
        <mat-icon [matBadge]="jobs.length" matBadgeColor="accent"
          >work</mat-icon
        >
      </button>
    }
  }
} @else {
  <mat-progress-spinner></mat-progress-spinner>
}
